import React from 'react';
import { useLocation } from 'react-router';
import { Alert } from 'react-bootstrap';


const HomepageAlertBanner = () => {
  const location = useLocation();
  let hideFooter = location.pathname !== "/Dashboard";
  hideFooter = true;

  return (
     <React.Fragment>  
      {hideFooter ? <></> :
        <Alert className="environment-component-banner d-print-none alert-info" variant="secondary">
          Starting April 14, SureImpact will begin requiring multi-factor authentication.  This will require either a phone number or an authenticator app.
        </Alert>
      }
    </React.Fragment>
  );
};

export default HomepageAlertBanner;
